import React, {Component, PropTypes} from 'react'
import {connect} from "react-redux"
import styles from './clientProfileEdit.scss'
import {setClientSubModule, setOpened, setOpenedSubmenu, initializeProfileForm} from 'state/actions'
import i18n from 'lib/i18n'
import {trimObject, hasContent} from 'lib/helpers'
import underscore from 'underscore'
import ClientProfileForm from './clientProfileForm'

const _ = i18n('clients')

/**
 * Create connect to get requested states and actions
 */
@connect(state => {
    const clientId = state.app.opened
    const clientData = state.clients.clientData[clientId]
    const appLanguage = state.app.lang
    const clientAccess = state.app.security.actions

	const canModifyOnlyLegalClient = clientAccess && clientAccess.filter((item)=>(item.actionName == "modifyonlylegalclient" && item.actionAllowed == "true")).length > 0

	return ({
		clientId: clientId,
		appLanguage: appLanguage,
		clientData: clientData,
        initializeProfileForm,
		canModifyOnlyLegalClient
	})
})

/**
 * Creates the edit profile page
 */
export default class ClientProfileEdit extends Component
{
	constructor(props) {
		super(props)
	}

    componentWillMount() {
        const {clientId, appLanguage, clientData, dispatch, initializeProfileForm} = this.props
        dispatch(initializeProfileForm(clientData, clientId, 'edit'))
    }

	/**
	 * Implements the render function for the component
	 * Renders the component form data
	 */
	render()
	{
		const { setSubModule,canCreateOnlyLegalClient, canModifyOnlyLegalClient } = this.props

		return(
			<div className={styles.profileClient}>
				<div className={styles.moduleSection}>
					<div className={styles.moduleSectionHeading}>
						{_('edit-profile')}
					</div>
					<ClientProfileForm
						setSubModule={setSubModule}
						canModifyOnlyLegalClient={canModifyOnlyLegalClient}
					/>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/clients/clientProfileEdit.jsx